var map = {
	"./B2_logo.png": 542,
	"./backArrow.png": 216,
	"./close.png": 270,
	"./cross.png": 543,
	"./dashboard/chrome.png": 544,
	"./dashboard/contact-icon.png": 545,
	"./dashboard/download.png": 546,
	"./dashboard/files-icon.png": 547,
	"./dashboard/firefox.png": 548,
	"./dashboard/gallery.jpg": 549,
	"./dashboard/gallery.png": 550,
	"./dashboard/ie.png": 551,
	"./dashboard/light.jpg": 552,
	"./dashboard/light.png": 553,
	"./dashboard/mouse-icon-sm.png": 554,
	"./dashboard/mouse-icon.png": 555,
	"./dashboard/project-icon.png": 556,
	"./dashboard/rich-icon-sm.png": 557,
	"./dashboard/rich-icon.png": 558,
	"./dashboard/safari.png": 559,
	"./dashboard/shopping-bag-icon-sm.png": 560,
	"./dashboard/shopping-bag-icon.png": 561,
	"./dashboard/tasks-icon.png": 562,
	"./dashboard/teams-icon.png": 563,
	"./favicon-32x32.png": 564,
	"./favicon.ico": 565,
	"./hyphen.png": 84,
	"./logo-color.png": 566,
	"./logo.png": 567,
	"./marker.png": 568,
	"./menu-icon.png": 569,
	"./pentagon.png": 570,
	"./pentagon_1.png": 571,
	"./placeholder.jpg": 572,
	"./safee_logo_square.png": 164,
	"./tick.png": 44,
	"./widget/birds.png": 573,
	"./widget/bread.png": 574,
	"./widget/building.png": 575,
	"./widget/disc.png": 576,
	"./widget/flying.png": 577,
	"./widget/glass.png": 578,
	"./widget/noodles.png": 579
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 541;